import { useStores } from 'src/contexts/stores';

export default function useDutchiePayEnrollment(): any {
  const { DutchiePayEnrollment } = useStores();

  return DutchiePayEnrollment;
}
